
export default {
  name: 'score-ponderation',
  components: {},
  props: [],
  data () {
    return {
      point:0,
      conclusion: '',
      
    }
  },
  watch:{
    facteursPonderations(){
       this.point = 0

       console.log("P: ",this.facteursPonderations);
       
       
       for(var i =0; i<this.facteursPonderations.length;i++){
         if(parseInt(this.facteursPonderations[i].selected) ===1){
           this.point += parseInt(this.facteursPonderations[i].facteur_ponderation)
         }
       }
       if(this.point ===0){
         this.conclusion = " CPN à suivre"
       } else if(this.point ===1){
        this.conclusion = "Surveiller"
      } else if(this.point ===2){
        this.conclusion = "Conseiller ou surveiller ou traiter ou référer si nécessaire "
      }else {
        this.conclusion = "Réferer"
      }
    }
  },
  computed: {
    facteursPonderations(){
      return this.$store.getters["facteursPonderations"];
    },
    
   


  },
  mounted () {

  },
  methods: {

  }
}


